
import React, { useState } from "react";
import { getStoreLocalData } from "../../utils/localStorage";

const PaymentDetail = ({
  taxableAmount,
  gstAmount,
  totalPriceSum,
  gst,
  grandTotal,
  additionalChargesData,
  additionalDiscountData,
  additionalInfoIsCheckedGST,
  offerDiscountSum,
  checkedPackageSubscriptionOfferValue,
  enabledAmountRoundOff
}) => {

  const { storeLocalData } = getStoreLocalData();
  const [selectedItem, setSelectedItem] = useState(null);

  const handleItemPress = () => {
    setSelectedItem((prevSelectedItem) => !prevSelectedItem);
  };

  return (
    <div
      className="flex-1  shadow-2 px-3 mb-2"
      style={{
        backgroundColor: "#F6FAFF",
      }}
    >
      <div
        className={
          "flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
        }
        onClick={() => handleItemPress()}
      >
        <div className="flex justify-content-start align-items-center flex-1 ">
          <img
            src={"Laundy_App_Icons_Gifs/Other_Icons/Additional_Information.png"}
            resizeMode="cover"
            style={{
              width: 20,
              height: 20,
            }}
          />
          <p className=" text-lg font-medium capitalize ml-2">
            Payment Details ({storeLocalData?.currencySymbol} {Number(grandTotal?.toFixed(enabledAmountRoundOff))})
          </p>
        </div>
        <div>
          {!selectedItem ? (
            <i
              className="pi pi-angle-down"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          ) : (
            <i
              className="pi pi-angle-up"
              style={{ fontSize: "25px", cursor: "pointer", color: "#777" }}
            ></i>
          )}
        </div>
      </div>

      {selectedItem && (
        <div className="my-3">
          <div style={{ top: 15 }}>
            <div
              className="my-2 border-top-2"
              style={{
                borderTopColor: "#C1C9D3",
              }}
            ></div>
          </div>
          <div>
            <div className="flex flex-1 justify-content-between">
              <p className=" text-lg font-medium capitalize ml-2">Total Amount ({storeLocalData?.currencyName}) </p>
              <p className=" text-lg font-medium capitalize ml-2">{storeLocalData?.currencySymbol} {Number(totalPriceSum?.toFixed(enabledAmountRoundOff))}</p>
            </div>
            <div className="flex flex-1 justify-content-between">
              <p className=" text-lg font-medium capitalize ml-2">Total Charges ({storeLocalData?.currencyName})</p>
              <p className=" text-lg font-medium capitalize ml-2">{storeLocalData?.currencySymbol} {Number(additionalChargesData?.toFixed(enabledAmountRoundOff))}</p>
            </div>
            <div className="flex flex-1 justify-content-between">
              <p className=" text-lg font-medium capitalize ml-2">Total Discount ({storeLocalData?.currencyName})</p>
              <p className=" text-lg font-medium capitalize ml-2">- {storeLocalData?.currencySymbol} {Number(additionalDiscountData?.toFixed(enabledAmountRoundOff))}</p>
            </div>
            {offerDiscountSum > 0 && (
              <div className="flex flex-1 justify-content-between">
                <p className=" text-lg font-medium capitalize ml-2">Offers Discount ({storeLocalData?.currencyName})</p>
                <p className=" text-lg font-medium capitalize ml-2">- {storeLocalData?.currencySymbol} {Number(offerDiscountSum?.toFixed(enabledAmountRoundOff))}</p>
              </div>
            )}
            {checkedPackageSubscriptionOfferValue > 0 && (
              <div className="flex flex-1 justify-content-between">
                <p className=" text-lg font-medium capitalize ml-2">Subscription Discount ({storeLocalData?.currencyName})</p>
                <p className=" text-lg font-medium capitalize ml-2">- {storeLocalData?.currencySymbol} {Number(checkedPackageSubscriptionOfferValue?.toFixed(enabledAmountRoundOff))}</p>
              </div>
            )}
            {additionalInfoIsCheckedGST && (
              <React.Fragment>
                <div className="flex flex-1 justify-content-between">
                  <p className=" text-lg font-medium capitalize ml-2">Taxable Amount ({storeLocalData?.currencyName})</p>
                  <p className=" text-lg font-medium capitalize ml-2">{storeLocalData?.currencySymbol} {Number(taxableAmount?.toFixed(enabledAmountRoundOff))}</p>
                </div>

                <div className="flex flex-1 justify-content-between">
                  <p className=" text-lg font-medium capitalize ml-2">{storeLocalData?.taxType} ({storeLocalData?.currencyName}) {gst * 100}% </p>
                  <p className=" text-lg font-medium capitalize ml-2">{storeLocalData?.currencySymbol} {Number(gstAmount?.toFixed(enabledAmountRoundOff))}</p>
                </div>
              </React.Fragment>
            )}
          </div>
          <div style={{ top: 0 }}>
            <div
              className="my-2 border-top-2"
              style={{
                borderTopColor: "#C1C9D3",
              }}
            ></div>
          </div>
          <div >
            <div className="flex flex-1 justify-content-between">
              <p className=" text-xl font-medium capitalize ml-2">Grand Total </p>
              <p className=" text-xl font-medium capitalize ml-2">{storeLocalData?.currencySymbol} {Number(grandTotal.toFixed(enabledAmountRoundOff))}</p>
            </div>
          </div>
        </div>
      )}
      <div></div>
    </div>
  );
};

export default PaymentDetail;
